const JsGallery = {
  init () {

    /*              __
                   / _)         
            .-^^^-/ /          
        __/       /              
        <__.|_|-|_|  

        The Emagine Dinosaur says; "We need to cater for everyone, some people want big fonts, some want small fonts, give them the choice.".          
    */

    if ( $('.c-gallery').length ) {

      // Lightgallery galirry...galle ..galery .. gallerellery .. um yeah .. pretty pictures
      $('.c-gallery').lightGallery({
          selector: '.gallery',
          thumbnail: true,
          // showThumbByDefault: false
      });

    }

  }
};

export default JsGallery;


// WEBPACK FOOTER //
// ./src/components/03-ui/gallery/gallery.js